export default "__VITE_ASSET__BuFDuqGf__"